import { AddressType, LoadingStatusType, PeakExceptionResponseCode, TypeComponentNoti } from "@/enums/enums";
import {
  ConvertToContactTable,
  ConvertToContactTemplateFromRd,
  ExceptionCheckDuplicate,
  ExceptionInsertContactTemplate,
  InputInsertContactTemplate,
  InputInsertContactTemplateBasic,
  SetContactCreateTemplate,
  SetContactCreateTemplateBySearchedContactAddress,
  SetContactCreateTemplateBySearchedContactAddressFailed,
  SetContactTemplateForEdit,
  SetHeaderTableContact,
  SetTabsContactTable,
  ValidateInsertContact,
} from "@/helper/contactHelper";
import { GetErrorMessageByExceptionCode, NewObject } from "@/helper/shareHelper";
import { i18n } from "@/i18n";
import { ContactCreateTemplateModel, ElementDefaultModel } from "@/model/contact/contactModel";
import API from "@/service/Index";
import {
  ConvertToContactDetail,
  ConvertToContactList,
  ConvertToContactSearchFirst,
  GetContactIdListForFavorite,
  ToContactPersonDetailList,
  ToSearchedContactAddress,
} from "@/service/contact/contactFacade";
import { TranslateResult } from "vue-i18n";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";
@Module({ namespaced: true })
export default class Contact extends VuexModule {
  private searchedContactAddressLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private searchedContact: any = null;
  private contactTableListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactTableList: any | null = null;
  private headerContactTable: any | null = null;
  private contactTableCount: any | null = null;
  private tabsContactTable: any = [];
  private contactCreateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactDuplicate = {
    contactName: "",
    isAllowCreateContactDuplicate: false,
  };
  private contactCreateId = 0;
  private contactCreate: any = null;
  private isOpenModalConfirmDuplicateName = false;
  private defaultContactTemplateFromRd: any = null;
  private defaultContactTemplateFromRdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private searchContactTemplateFromRd: any = null;
  private searchContactTemplateFromRdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactDetail: any = [];
  private contactIsArchivedLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactPersonDetailList: any = [];
  private contactPersonListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private autoCompleteContactListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private autoCompleteContactList: any = [];
  private autoCompleteContactListDefault: any = [];
  private autoCompleteContactListSequenceNumber = 0;
  private autoCompleteContactListSearchText = "";
  private contactModelList: any = [];
  private contactModelListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private favoriteContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactListByFavorite: any = null;
  private updateFavoriteContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private deleteFavoriteContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactCreateTemplate: ContactCreateTemplateModel = SetContactCreateTemplate();
  private contactIsCanDeleteLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private contactIsCanDelete = false;
  private deleteContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getUpdateFavoriteContactLoadingStatus() {
    return this.updateFavoriteContactLoadingStatus;
  }
  get getDeleteFavoriteContactLoadingStatus() {
    return this.deleteFavoriteContactLoadingStatus;
  }
  get getDetailCreateContact() {
    return this.contactCreateTemplate;
  }
  get getFavoriteContactLoadingStatus() {
    return this.favoriteContactLoadingStatus;
  }
  get getContactListByFavorite() {
    return this.contactListByFavorite;
  }
  get getContactPersonDetailList() {
    return this.contactPersonDetailList;
  }
  get getContactPersonListLoadingStatus(): LoadingStatusType {
    return this.contactPersonListLoadingStatus;
  }
  get getContactCodeLoadingStatus(): LoadingStatusType {
    return this.contactCodeLoadingStatus;
  }
  get getContactCode(): ElementDefaultModel {
    return this.contactCreateTemplate.contactCode;
  }
  get getSearchedContactAddressLoadingStatus(): LoadingStatusType {
    return this.searchedContactAddressLoadingStatus;
  }
  get getSearchedContact(): any {
    return this.searchedContact;
  }
  get getContactTableListLoadingStatus(): LoadingStatusType {
    return this.contactTableListLoadingStatus;
  }
  get getContactTableList(): any {
    return this.contactTableList;
  }
  get getTabsContactTable(): any {
    return this.tabsContactTable;
  }
  get getHeaderContactTable(): any {
    return this.headerContactTable;
  }
  get getContactCreateId(): number {
    return this.contactCreateId;
  }
  get getContactCreate(): any {
    return this.contactCreate;
  }
  get getContactCreateLoadingStatus(): LoadingStatusType {
    return this.contactCreateLoadingStatus;
  }
  get checkOpenModalConfirmDuplicateName(): boolean {
    return this.isOpenModalConfirmDuplicateName;
  }
  get getContactDuplicateName(): any {
    return this.contactDuplicate;
  }
  get getDefaultContactTemplateFromRd(): any {
    return this.defaultContactTemplateFromRd;
  }
  get getDefaultContactTemplateFromRdLoadingStatus(): LoadingStatusType {
    return this.defaultContactTemplateFromRdLoadingStatus;
  }
  get getSearchContactTemplateFromRd(): any {
    return this.searchContactTemplateFromRd;
  }
  get getSearchContactTemplateFromRdLoadingStatus(): LoadingStatusType {
    return this.searchContactTemplateFromRdLoadingStatus;
  }
  get getcontactDetailLoadingStatus(): LoadingStatusType {
    return this.contactDetailLoadingStatus;
  }
  get getContactDetail() {
    return this.contactDetail;
  }
  get getcontactIsArchivedLoadingStatus(): LoadingStatusType {
    return this.contactIsArchivedLoadingStatus;
  }

  get getAutoCompleteContactList() {
    return this.autoCompleteContactList;
  }

  get getAutoCompleteContactListLoadingStatus() {
    return this.autoCompleteContactListLoadingStatus;
  }

  get getAutoCompleteContactListSequenceNumber() {
    return this.autoCompleteContactListSequenceNumber;
  }

  get getAutoCompleteContactListSearchText() {
    return this.autoCompleteContactListSearchText;
  }

  get getContactModelList() {
    return this.contactModelList;
  }

  get getContactModelListLoadingStatus() {
    return this.contactModelListLoadingStatus;
  }

  get getContactIsCanDeleteLoadingStatus() {
    return this.contactIsCanDeleteLoadingStatus;
  }

  get getContactIsCanDelete() {
    return this.contactIsCanDelete;
  }

  get getDeleteContactLoadingStatus() {
    return this.deleteContactLoadingStatus;
  }

  @Mutation
  public MutationSetContactCodeLoadingStatus(status: LoadingStatusType) {
    this.contactCodeLoadingStatus = status;
  }
  @Mutation
  public MutationSetSearchedContactAddressLoadingStatus(status: LoadingStatusType) {
    this.searchedContactAddressLoadingStatus = status;
  }
  @Mutation
  MutationGetSearchedContactAddress(searchedAddress: any) {
    this.searchedContact = {
      addressSource: searchedAddress.addressSource,
      addressType: searchedAddress.addressType,
    };
  }
  @Mutation
  MutationContactTableListLoadingStatus(status: LoadingStatusType) {
    this.contactTableListLoadingStatus = status;
  }
  @Mutation
  MutationContactTableList(message: any) {
    this.contactTableList = message.contactTable.contactTableList;

    this.tabsContactTable = SetTabsContactTable();

    this.tabsContactTable.forEach((tap: any) => {
      if (tap.contactTableViewStatusType == message.tableStatus) {
        tap.length = message.contactTable.contactTableCount;
        tap.active = true;
      } else {
        tap.length = 0;
        tap.active = false;
      }
    });
  }
  @Mutation
  MutationsSetHeaderTableContact(sorting: any | null = null) {
    this.headerContactTable = SetHeaderTableContact();
    if (sorting) {
      this.headerContactTable.forEach((item: any) => {
        if (item.sortBy == sorting.sortBy) {
          item.sortingType = sorting.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  MutationContactCreateLoadingStatus(status: LoadingStatusType) {
    this.contactCreateLoadingStatus = status;
  }
  @Mutation
  MutationInsertContact(inserted: any) {
    this.contactCreateId = inserted.contactId;
    this.contactCreate = inserted;
  }

  @Mutation
  MutationContactDuplicate(input: any) {
    this.contactDuplicate.contactName = input.contactName;
    this.contactDuplicate.isAllowCreateContactDuplicate = input.isAllowCreateContactDuplicate;
  }

  @Mutation
  MutationOpenModalConfirmDuplicateName(status: boolean) {
    this.isOpenModalConfirmDuplicateName = status;
  }

  @Mutation
  MutationUpdateGetDefaultContactTemplateFromRdLoadingStatus(loadingStatus: LoadingStatusType) {
    this.defaultContactTemplateFromRdLoadingStatus = loadingStatus;
  }
  @Mutation
  MutationGetDefaultContactTemplateFromRd(contactTemplate: any) {
    this.defaultContactTemplateFromRd = contactTemplate;
  }
  @Mutation
  MutationUpdateGetSearchContactTemplateFromRdLoadingStatus(loadingStatus: LoadingStatusType) {
    this.searchContactTemplateFromRdLoadingStatus = loadingStatus;
  }
  @Mutation
  MutationGetSearchContactTemplateFromRd(contactTemplate: any) {
    this.searchContactTemplateFromRd = contactTemplate;
  }

  @Mutation
  MutationGetContactListByFavorite(contactFavoriteModel: any) {
    this.contactListByFavorite = contactFavoriteModel;
  }

  @Mutation
  public MutationFavoriteContactLoadingStatus(status: LoadingStatusType) {
    this.favoriteContactLoadingStatus = status;
  }

  @Mutation
  public MutationDeleteFavoriteContactLoadingStatus(status: LoadingStatusType) {
    this.deleteFavoriteContactLoadingStatus = status;
  }

  @Mutation
  public MutationUpdateFavoriteContactLoadingStatus(status: LoadingStatusType) {
    this.updateFavoriteContactLoadingStatus = status;
  }

  @Mutation
  public MutationContactPersonListLoadingStatus(status: LoadingStatusType) {
    this.contactPersonListLoadingStatus = status;
  }

  @Mutation
  public MutationContactPersonList(contactPersonDetailList: any) {
    this.contactPersonDetailList = contactPersonDetailList;
  }
  @Mutation
  public MutationContactDetailLoadingStatus(status: LoadingStatusType) {
    this.contactDetailLoadingStatus = status;
  }
  @Mutation
  public MutationContactDetail(contactDetail: any) {
    this.contactDetail = contactDetail;
  }
  @Mutation
  public MutationResetContactDetail(contactDetail: any) {
    this.contactDetail = SetContactCreateTemplate();
  }
  @Mutation
  protected MutationContactIsArchivedLoadingStatus(status: LoadingStatusType) {
    this.contactIsArchivedLoadingStatus = status;
  }

  @Mutation
  public MutationAutoCompleteContactListSequenceNumber(_sequenceNumber: number) {
    this.autoCompleteContactListSequenceNumber = _sequenceNumber;
  }

  @Mutation
  public MutationAutoCompleteContactListSearchText(_searchText: string) {
    this.autoCompleteContactListSearchText = _searchText;
  }

  @Mutation
  public MutationSetAutoCompleteContactListLoadingStatus(status: LoadingStatusType) {
    this.autoCompleteContactListLoadingStatus = status;
  }

  @Mutation
  public MutationAutoCompleteContactList(_contactList: any) {
    this.autoCompleteContactList = _contactList;
  }

  @Mutation
  MutationAutoCompleteContactListDefault(_contactList: any) {
    this.autoCompleteContactListDefault = _contactList;
  }

  @Mutation
  public MutationSetContactModelListLoadingStatus(status: LoadingStatusType) {
    this.contactModelListLoadingStatus = status;
  }

  @Mutation
  public MutationContactModelList(_contactModelList: any) {
    this.contactModelList = [...this.contactModelList, ..._contactModelList];
  }

  @Mutation
  public MutationResetContactCreate() {
    this.contactCreateId = 0;
    this.contactCreate = null;
  }

  @Mutation
  public MutationContactCreateTemplate(contactTemplate: ContactCreateTemplateModel) {
    this.contactCreateTemplate = contactTemplate;
    this.searchedContactAddressLoadingStatus = LoadingStatusType.None;
  }

  @Mutation
  public MutationReSetContactModelList() {
    this.contactModelList = [];
  }

  @Mutation
  public MutationUpdateContactIsCanDeleteLoadingStatus(status: LoadingStatusType) {
    this.contactIsCanDeleteLoadingStatus = status;
  }

  @Mutation
  public MutationUpdateContactIsCanDelete(value: boolean) {
    this.contactIsCanDelete = value;
  }

  @Mutation
  public MutationUpdateDeleteContactLoadingStatus(status: LoadingStatusType) {
    this.deleteContactLoadingStatus = status;
  }

  @Mutation
  public MutationUpdateGetDetailCreateContact(value: Record<string, any>) {
    this.contactCreateTemplate = NewObject(value);
  }

  @Mutation
  public MutationResetContactList() {
    this.contactTableList = [];
  }

  @Action
  public UpdateGetDetailCreateContact(value: Record<string, any>) {
    this.context.commit("MutationUpdateGetDetailCreateContact", value);
  }

  @Action
  public DoResetContactDetail() {
    this.context.commit("MutationResetContactDetail");
    this.context.commit("MutationContactDetailLoadingStatus", LoadingStatusType.None);
  }

  @Action
  public DoResetContactList() {
    this.context.commit("MutationResetContactList");
    this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.None);
    this.context.commit("MutationAutoCompleteContactListDefault", []);
  }

  @Action
  public DoEditContactModal() {
    if (this.contactCreateLoadingStatus !== LoadingStatusType.Loading) {
      const insertContactTemplate = this.contactCreateTemplate;
      const validateInsertContact = ValidateInsertContact(insertContactTemplate);

      if (validateInsertContact) {
        this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Loading);
        const inputInsertContactTemplate = InputInsertContactTemplate(insertContactTemplate);
        store.dispatch("Loading/IsLoading", true);
        API.ContactService.DoEditContact(inputInsertContactTemplate).then((res) => {
          let alertMessage: any = "";
          let typeMessage = TypeComponentNoti.success;

          if (res.data.responseCode.IsSuccess()) {
            alertMessage = i18n.t("Edited_Contact_Success", { msg: inputInsertContactTemplate.code });
            this.context.dispatch("DoResetContactList");
            this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Success);
          } else {
            alertMessage = ExceptionInsertContactTemplate(res.data, this.contactCreateTemplate);
            const contactDuplicate = ExceptionCheckDuplicate(res.data, this.contactCreateTemplate);
            this.context.commit("MutationContactCreateLoadingStatus", {
              contactName: contactDuplicate.contactName.value,
              isAllowCreateContactDuplicate: false,
            });
            this.context.commit("MutationOpenModalConfirmDuplicateName", contactDuplicate.contactNameIsDuplicated);
            typeMessage = TypeComponentNoti.error;
            this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.None);
          }
          store.dispatch("Alert/SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          });
        });
        store.dispatch("Loading/IsLoading", false);
      } else {
        store.dispatch("Alert/SetAlertMessage", {
          alertMessage: i18n.t("AlertNoti_Create_Input_Error"),
          typeMessage: TypeComponentNoti.error,
        });
        this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Fail);
        setTimeout(() => {
          this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.None);
        }, 500);
      }
    }
  }

  @Action
  public DoGetContactPersonList(contactId: any) {
    if (this.contactPersonListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationContactPersonListLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetContactPersonList(contactId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactPersonDetailModel = ToContactPersonDetailList(res.data.contactPersonDetailModel);
          this.context.commit("MutationContactPersonList", contactPersonDetailModel);
        }
        this.context.commit("MutationContactPersonListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public SetSearchedContactAddressLoadingStatus(status: LoadingStatusType) {
    this.context.commit("MutationSetSearchedContactAddressLoadingStatus", status);
  }

  @Action
  public DoGetSuggestContactCode(contactCreateTemplate: ContactCreateTemplateModel) {
    if (this.contactCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetContactCodeLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetSuggestContactCode().then((res) => {
        contactCreateTemplate.contactCode.value = res.data.contactCode;
        this.context.commit("MutationSetContactCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetSearchedContactAddress(contactCreateTemplate: ContactCreateTemplateModel) {
    if (contactCreateTemplate.taxId.value.toString().length === 13) {
      if (this.searchedContactAddressLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Loading);
        const input = {
          taxId: contactCreateTemplate.taxId.value,
          branchCode: contactCreateTemplate.branchCode.value ? contactCreateTemplate.branchCode.value : "00000",
        };
        API.ContactService.DoGetSearchedContactAddress(input).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const searchedAddress = ToSearchedContactAddress(res.data.searchedAddress);

            if (searchedAddress.addressType !== AddressType.NoAddress) {
              SetContactCreateTemplateBySearchedContactAddress(contactCreateTemplate, searchedAddress);
            } else {
              SetContactCreateTemplateBySearchedContactAddressFailed(contactCreateTemplate);
            }
            this.context.commit("MutationGetSearchedContactAddress", searchedAddress);
          }
          this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Success);
        });
      }
    } else {
      SetContactCreateTemplateBySearchedContactAddressFailed(contactCreateTemplate);
    }
  }
  @Action
  public DoGetContactTable(input: any) {
    if (this.contactTableListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationContactTableListLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetContactTable(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactTable = ConvertToContactTable(res.data.contactTable);

          const message = {
            contactTable: contactTable,
            tableStatus: input.tableStatus,
            contactGroupId: input.contactGroupId,
          };

          this.context.commit("MutationContactTableList", message);
          this.context.commit("MutationsSetHeaderTableContact", {
            sortBy: input.contactTableView,
            sortingType: input.tableSorting,
          });
        }
        this.context.commit("MutationContactTableListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoInsertContact(input: any) {
    if (this.contactCreateLoadingStatus !== LoadingStatusType.Loading) {
      let insertContactTemplate;
      if (input.contactCreateTemplate.modalCreateType == 1) {
        const setContactCreateTemplate = SetContactCreateTemplate();
        insertContactTemplate = InputInsertContactTemplateBasic(input.contactCreateTemplate, setContactCreateTemplate);
      } else {
        insertContactTemplate = input.contactCreateTemplate;
      }

      const validateInsertContact = ValidateInsertContact(insertContactTemplate);

      if (validateInsertContact) {
        this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Loading);
        const inputInsertContactTemplate = InputInsertContactTemplate(insertContactTemplate);
        API.ContactService.DoCreateContact(
          inputInsertContactTemplate,
          this.contactDuplicate.isAllowCreateContactDuplicate
        ).then((res) => {
          let alertMessage: any = "";
          let typeMessage = TypeComponentNoti.success;

          if (res.data.responseCode.IsSuccess()) {
            alertMessage = i18n.t("Added_Contact_Success", { msg: inputInsertContactTemplate.code });
            this.context.commit("MutationInsertContact", {
              contactId: res.data.contactId,
              contactCode: inputInsertContactTemplate.code,
              sequenceNumber: input.sequenceNumber,
            });
            this.context.dispatch("DoResetContactList");
            store.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: typeMessage,
              },
              { root: true }
            );
            this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Success);
          } else {
            if (res.data.exception.code === PeakExceptionResponseCode.CanNotCreateContactHaveMaximumContact) {
              alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
            } else {
              alertMessage = ExceptionInsertContactTemplate(res.data, input.contactCreateTemplate);
              const contactDuplicate = ExceptionCheckDuplicate(res.data, input.contactCreateTemplate);
              this.context.commit("MutationContactDuplicate", {
                contactName: contactDuplicate.contactName.value,
                isAllowCreateContactDuplicate: false,
              });

              if (res.data.exception.code === PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContact) {
                this.context.commit("MutationOpenModalConfirmDuplicateName", false);
              } else {
                this.context.commit("MutationOpenModalConfirmDuplicateName", contactDuplicate.contactNameIsDuplicated);
              }
            }

            typeMessage = TypeComponentNoti.error;
            store.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: typeMessage,
              },
              { root: true }
            );
            this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.None);
          }
        });
      } else {
        store.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("AlertNoti_Create_Input_Error"),
            typeMessage: TypeComponentNoti.error,
          },
          { root: true }
        );
        this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.Fail);
        setTimeout(() => {
          this.context.commit("MutationContactCreateLoadingStatus", LoadingStatusType.None);
        }, 500);
      }
    }
  }

  @Action ResetContactCreate() {
    this.context.commit("MutationResetContactCreate");
  }

  @Action
  DoGetDefaultContactTemplateFromRd() {
    if (this.defaultContactTemplateFromRdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateGetDefaultContactTemplateFromRdLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetDefaultContactTemplateFromRd().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationGetDefaultContactTemplateFromRd", res.data.contactTemplateModelList);
          this.context.commit("MutationUpdateGetDefaultContactTemplateFromRdLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  DoSearchContactTemplateFromRd(searchText: string) {
    if (this.getSearchContactTemplateFromRdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateGetSearchContactTemplateFromRdLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetSearchContactTemplateFromRd(searchText).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactTemplateModelList = ConvertToContactTemplateFromRd(res.data.contactTemplateModelList);
          this.context.commit("MutationGetSearchContactTemplateFromRd", contactTemplateModelList);
          this.context.commit("MutationUpdateGetSearchContactTemplateFromRdLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  DoSetContactTemplate(_input: any) {
    if (_input.contactTemplate.taxId.length === 13) {
      this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Loading);

      const input = {
        taxId: _input.contactTemplate.taxId,
        branchCode: _input.contactTemplate.branchCode ? _input.contactTemplate.branchCode : "00000",
      };

      API.ContactService.DoGetSearchedContactAddress(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const searchedAddress = ToSearchedContactAddress(res.data.searchedAddress);
          if (searchedAddress.addressType !== AddressType.NoAddress) {
            SetContactCreateTemplateBySearchedContactAddress(_input.contactCreateTemplate, searchedAddress);
          } else {
            SetContactCreateTemplateBySearchedContactAddress(_input.contactCreateTemplate, _input.contactTemplate);
          }
          this.context.commit("MutationGetSearchedContactAddress", searchedAddress);
          this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  DoGetContactDetailById(contactId: any) {
    if (this.getcontactDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationContactDetailLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetContactDetailByid(contactId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactDetailByid = ConvertToContactDetail(res.data.contactDetail);
          this.context.commit("MutationContactDetail", contactDetailByid);
          this.context.commit("MutationContactDetailLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }
  @Action
  DoUpdateIsArchivedContact(input: any) {
    if (this.getcontactIsArchivedLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationContactIsArchivedLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoUpdateIsArchivedContact(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationContactIsArchivedLoadingStatus", LoadingStatusType.Success);
        } else {
          store.dispatch("SetAlertMessage", {
            alertMessage: res.data.exception.errorMessage,
            typeMessage: TypeComponentNoti.error,
          });
          this.context.commit("MutationContactIsArchivedLoadingStatus", LoadingStatusType.None);
        }
      });
    }
  }

  @Action
  public DoGetContactByContactIdList(contactIdList: Array<number>) {
    return new Promise((resolve) => {
      if (this.contactModelListLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Loading);
        contactIdList = [...new Set(contactIdList)];
        let contactIdForSearch = [] as Array<number>;
        if (this.contactModelList && this.contactModelList.length > 0) {
          contactIdList.forEach((contactId) => {
            const contactOnLocal = this.contactModelList.find((x: any) => x.id === contactId);
            if (!contactOnLocal) {
              contactIdForSearch.push(contactId);
            }
          });
        } else {
          contactIdForSearch = contactIdList;
        }

        if (contactIdForSearch.length > 0) {
          API.ContactService.DoGetContactByContactIdList(contactIdForSearch).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const contactModelList = ConvertToContactList(res.data.contactList);
              this.context.commit("MutationContactModelList", contactModelList);
            }
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          });
        } else {
          setTimeout(() => {
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          }, 250);
        }
      }
    });
  }

  @Action
  public DoGetContactByContactIdListAsync(contactIdList: Array<number>): Promise<void> {
    return new Promise((resolve) => {
      contactIdList = [...new Set(contactIdList)];
      let contactIdForSearch = [] as Array<number>;
      if (this.contactModelList && this.contactModelList.length > 0) {
        contactIdList.forEach((contactId) => {
          const contactOnLocal = this.contactModelList.find((x: any) => x.id === contactId);
          if (!contactOnLocal) {
            contactIdForSearch.push(contactId);
          }
        });
      } else {
        contactIdForSearch = contactIdList;
      }

      if (contactIdForSearch.length > 0) {
        API.ContactService.DoGetContactByContactIdList(contactIdForSearch).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactModelList = ConvertToContactList(res.data.contactList);
            this.context.commit("MutationContactModelList", contactModelList);
          }
          resolve();
        });
      } else {
        setTimeout(() => {
          resolve();
        }, 250);
      }
    });
  }

  @Action
  public DoGetFavoriteContactModelList(favoriteTypeId: any) {
    if (this.favoriteContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationFavoriteContactLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetFavoriteContactModelList(favoriteTypeId).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const outputModel = {
            favoriteContactIdList: [],
            suggestContactIdList: [],
            contactIdListFavoriteOutPut: [],
          };
          const contactIdList: any = GetContactIdListForFavorite(res.data.data);
          if (contactIdList.length > 0) {
            outputModel.contactIdListFavoriteOutPut = contactIdList;
            await store.dispatch("Contact/DoGetContactByContactIdListAsync", contactIdList, { root: true });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          if (contactList && contactList.length > 0) {
            if (res.data.data.favoriteContactIdList && res.data.data.favoriteContactIdList.length > 0) {
              const contactListByFavorite: any = [];
              res.data.data.favoriteContactIdList.forEach((contactId: any) => {
                const selectContact = contactList.find((x: any) => x.id == contactId);
                if (selectContact) {
                  contactListByFavorite.push(selectContact);
                }
              });
              outputModel.favoriteContactIdList = contactListByFavorite;
            }
            if (res.data.data.suggestContactIdList && res.data.data.suggestContactIdList.length > 0) {
              const contactListByFavorite: any = [];
              res.data.data.suggestContactIdList.forEach((contactId: any) => {
                const selectContact = contactList.find((x: any) => x.id == contactId);
                if (selectContact) {
                  contactListByFavorite.push(selectContact);
                }
              });
              outputModel.suggestContactIdList = contactListByFavorite;
            }
          }
          this.context.commit("MutationGetContactListByFavorite", outputModel);
        }
        this.context.commit("MutationFavoriteContactLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoDeleteFavoriteContact(input: any) {
    if (this.deleteFavoriteContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationDeleteFavoriteContactLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoDeleteFavoriteContact(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationFavoriteContactLoadingStatus", LoadingStatusType.None);
        }
        this.context.commit("MutationDeleteFavoriteContactLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateFavoriteContact(input: any) {
    if (this.updateFavoriteContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateFavoriteContactLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoUpdateFavoriteContact(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationFavoriteContactLoadingStatus", LoadingStatusType.None);
        }
        this.context.commit("MutationUpdateFavoriteContactLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  DoValidateCanDeleteContact(contactId: string) {
    if (this.contactIsCanDeleteLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateContactIsCanDeleteLoadingStatus", LoadingStatusType.Loading);
      store.dispatch("Loading/IsLoading", true);
      API.ContactService.DoValidateCanDeleteContact(contactId)
        .then((res) => {
          this.context.commit("MutationUpdateContactIsCanDelete", res.data.isCanDeleteContact);
          this.context.commit("MutationUpdateContactIsCanDeleteLoadingStatus", LoadingStatusType.Success);
          store.dispatch("Loading/IsLoading", false);
        })
        .catch((error) => error);
    }
  }

  @Action
  DoDeleteContact(input: Record<string, any>) {
    let alertMessage: string | TranslateResult = "";
    let typeMessage = TypeComponentNoti.success;
    if (this.deleteContactLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateDeleteContactLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoDeleteContact(input.contactId)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            alertMessage = i18n.t("Delete_Contact_Success", { code: input.contactCode, name: input.contactName });
            this.context.commit("MutationUpdateDeleteContactLoadingStatus", LoadingStatusType.Success);
          } else {
            alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
            typeMessage = TypeComponentNoti.error;
            this.context.commit("MutationUpdateDeleteContactLoadingStatus", LoadingStatusType.None);
          }
          store.dispatch("Alert/SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          });
        })
        .catch((error) => error);
    }
  }
  @Action
  public SetEditContactModal(input: ContactCreateTemplateModel) {
    const setContactCreateTemplate = SetContactCreateTemplate();
    SetContactTemplateForEdit(setContactCreateTemplate, input);
    this.context.commit("MutationContactCreateTemplate", setContactCreateTemplate);
  }

  @Action SetContactCreateTemplateForEdit(input: ContactCreateTemplateModel) {
    this.context.commit("MutationContactCreateTemplate", input);
  }

  @Action
  public DoGetContactSearchFirst(input: any) {
    if (this.autoCompleteContactListLoadingStatus !== LoadingStatusType.Loading) {
      const searchText = input.searchText ? input.searchText.trim() : input.searchText;
      this.context.commit("MutationAutoCompleteContactListSequenceNumber", input.sequenceNumber);
      this.context.commit("MutationAutoCompleteContactListSearchText", input.searchText);
      this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Loading);
      let isLoadContactList = true;
      if (searchText == "") {
        const contactListDefault = this.autoCompleteContactListDefault;
        if (contactListDefault && contactListDefault.length > 0) {
          this.context.commit("MutationAutoCompleteContactList", contactListDefault);
          isLoadContactList = false;
          setTimeout(() => {
            this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
          }, 250);
        }
      }
      if (isLoadContactList) {
        API.ContactService.DoGetContactSearchFirst().then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactList = ConvertToContactSearchFirst(res.data.contactSearchList);
            this.context.commit("MutationAutoCompleteContactListDefault", contactList);
            this.context.commit("MutationAutoCompleteContactList", contactList);
          }
          this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
        });
      }
    }
  }

  @Action
  public DoGetContactSearchWithSearchText(input: any) {
    if (this.autoCompleteContactListLoadingStatus !== LoadingStatusType.Loading) {
      const searchText = input.searchText ? input.searchText.trim() : input.searchText;
      this.context.commit("MutationAutoCompleteContactListSequenceNumber", input.sequenceNumber);
      this.context.commit("MutationAutoCompleteContactListSearchText", input.searchText);
      this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Loading);
      let isLoadContactList = true;
      if (searchText == "") {
        const contactListDefault = this.autoCompleteContactListDefault;
        if (contactListDefault && contactListDefault.length > 0) {
          this.context.commit("MutationAutoCompleteContactList", contactListDefault);
          isLoadContactList = false;
          setTimeout(() => {
            this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
          }, 250);
        }
      }
      if (isLoadContactList) {
        API.ContactService.DoGetContactSearchWithSearchText(searchText).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const contactList = ConvertToContactSearchFirst(res.data.contactSearchList);
            this.context.commit("MutationAutoCompleteContactList", contactList);
          }
          this.context.commit("MutationSetAutoCompleteContactListLoadingStatus", LoadingStatusType.Success);
        });
      }
    }
  }
}
